import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Menu"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-menu',
    templateUrl: './icon-menu.component.html',
    styleUrls: ['./icon-menu.component.scss'],
    standalone: false
})
export class IconMenuComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
